import { useMutation, useQueryClient } from '@tanstack/react-query';

import { checklistApi } from '@features/Checklist/api';

export const useDeleteChecklist = (onDeleteSuccessCb?: () => void) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: checklistApi.deleteChecklistDataQuery,
        onSuccess: async (res, deletedId) => {
            if (res?.data?.status === 'success') {
                await queryClient.invalidateQueries({
                    queryKey: checklistApi.getChecklistDataQuery(deletedId).queryKey,
                });
                onDeleteSuccessCb?.();
            }
        },
    });
};
